import React from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
  Box,
  Button,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DescribedField from '../DescribedField';

const emptyItem = () => ({
  id: crypto.randomUUID(),
  q: '',
  a: '',
});

/**
 * FaqBlockEditor — Editor do bloco Perguntas Frequentes
 * TODO 4.17
 *
 * Props:
 *   - value: { items: [{ id, q, a }] }
 *   - onChange: (patch) => void
 *   - context: object
 */
const FaqBlockEditor = ({ value = {}, onChange }) => {
  const { items = [] } = value;

  const patchItems = (newItems) => onChange({ ...value, items: newItems });

  const addItem = () => patchItems([...items, emptyItem()]);

  const removeItem = (index) => patchItems(items.filter((_, i) => i !== index));

  const updateItem = (index, field, val) => {
    const updated = items.map((item, i) =>
      i === index ? { ...item, [field]: val } : item
    );
    patchItems(updated);
  };

  return (
    <DescribedField
      label="Perguntas frequentes"
      description="Pares de pergunta e resposta exibidos em accordion. Reduz dúvidas operacionais (horários, convênios, formas de pagamento) e melhora o SEO da página. Limite: pergunta até 150 caracteres, resposta até 500 caracteres."
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {items.map((item, index) => (
          <Paper key={item.id ?? index} variant="outlined" sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="subtitle2">Pergunta {index + 1}</Typography>
              <IconButton
                size="small"
                onClick={() => removeItem(index)}
                aria-label="Remover pergunta"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
            <TextField
              fullWidth
              label="Pergunta"
              value={item.q}
              onChange={(e) => updateItem(index, 'q', e.target.value)}
              size="small"
              inputProps={{ maxLength: 150 }}
              sx={{ mb: 1.5 }}
              helperText="Pergunta direta (ex.: 'Atendem por convênio?'). Até 150 caracteres."
            />
            <TextField
              fullWidth
              label="Resposta"
              value={item.a}
              onChange={(e) => updateItem(index, 'a', e.target.value)}
              size="small"
              multiline
              rows={3}
              inputProps={{ maxLength: 500 }}
              helperText="Resposta direta e objetiva. Até 500 caracteres."
            />
          </Paper>
        ))}

        <Button
          startIcon={<AddIcon />}
          onClick={addItem}
          variant="outlined"
          size="small"
          sx={{ alignSelf: 'flex-start' }}
        >
          Adicionar pergunta
        </Button>
      </Box>
    </DescribedField>
  );
};

FaqBlockEditor.propTypes = {
  value: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        q: PropTypes.string,
        a: PropTypes.string,
      })
    ),
  }),
  onChange: PropTypes.func.isRequired,
  context: PropTypes.object,
};

export default FaqBlockEditor;
